import React from 'react';

const AmazonAgreement = () => {
  return (
    <div className="page-container">
      <h1>Amazon Affiliate Agreement & Statement</h1>
      <p>Last updated: {new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}</p>

      <div
        style={{
          background: 'rgba(255, 153, 0, 0.1)',
          borderLeft: '4px solid #ff9900',
          padding: '16px 20px',
          borderRadius: '8px',
          margin: '20px 0 28px',
        }}
      >
        <p style={{ margin: 0, fontWeight: 700, color: '#ff9900', fontSize: '16px' }}>
          "As an Amazon Associate I earn from qualifying purchases."
        </p>
      </div>

      <h2>Amazon Associates Program Operating Disclosure</h2>
      <p>
        <strong>UpDeals</strong> (https://updeals.in) is a participant in the Amazon Services LLC
        Associates Program and the Amazon Seller Services Private Limited Associates Programme,
        an affiliate advertising program designed to provide a means for sites to earn advertising
        fees by advertising and linking to Amazon.in, Amazon.com, and affiliated properties.
      </p>

      <h2>Product Pricing and Availability Notice</h2>
      <p>
        Product prices and availability are accurate as of the date/time indicated and are subject
        to change. Any price and availability information displayed on Amazon at the time of purchase
        will apply to the purchase of this product.
      </p>
      <p>
        UpDeals does not control or guarantee the price, shipping fees, or inventory availability of
        products listed by sellers on Amazon.
      </p>

      <h2>Content and Media Attribution</h2>
      <p>
        Certain content that appears on this site comes from Amazon Services LLC or its affiliates.
        This content is provided "as is" and is subject to change or removal at any time without notice.
      </p>

      <h2>Trademark Notice</h2>
      <p>
        Amazon and the Amazon logo are trademarks of Amazon.com, Inc. or its affiliates. All other
        trademarks, service marks, and trade names are the property of their respective owners.
      </p>
    </div>
  );
};

export default AmazonAgreement;
